/**
 * Une CHAÎNE d'égalités dans une phrase à trous (2026-09-09, constat prof sur
 * 1059) : « 1 m³ = 1 m × 1 m × 1 m = ⬚ dm × ⬚ dm × ⬚ dm = ⬚ dm³ ».
 *
 * Ni l'écran ni le papier ne la voyaient comme UNE expression (« 1 m³ » fait
 * deux mots) : elle se coupait n'importe où. Découpée en une tête « 1 m³ » et
 * des membres « = 1 m × 1 m × 1 m », « = ⬚ dm × ⬚ dm × ⬚ dm », « = ⬚ dm³ »,
 * chacun insécable, elle ne peut plus se replier qu'au « = », les suites
 * alignées sous le premier « = », comme dans un manuel. Aucun seuil : c'est
 * le navigateur qui replie quand la place manque (téléphone, demi-colonne).
 *
 * Reconnue : au moins deux « = » entourés d'espaces ; aucun « ; » (une suite
 * d'égalités séparées se coupe déjà au « ; ») ; aucune formule $…$ ; aucun
 * mot de quatre lettres ou plus (« On a a = 3 et b = 5 » est une phrase, pas
 * une chaîne ; les unités m, dm, cm, mm, km, min font trois lettres au plus).
 * Le marqueur de trou est quelconque (jeton, « … », {{12}}).
 *
 * @returns {{ tete: string, membres: string[] } | null}
 */
export const membresChaine = (ligne) => {
    const s = String(ligne || '').trim();
    if (!s || /[;$\n]/.test(s) || /[A-Za-zÀ-ÿ]{4,}/.test(s)) return null;
    const parts = s.split(' = ');
    if (parts.length < 3 || parts.some((p) => !p.trim())) return null;
    return { tete: parts[0].trim(), membres: parts.slice(1).map((p) => `= ${p.trim()}`) };
};
